// extracted by mini-css-extract-plugin
export default {"root":"NavLink_root__DzCls","navLink":"NavLink_navLink__TZjjy","currentLocationUnderline":"NavLink_currentLocationUnderline__yG3Tu","rightArrow":"NavLink_rightArrow__4dRB2"};